<template lang="html">
<div class="c2h4-div__course">
  <h4 class="c2h4-h4__course__title">— 教程 —</h4>
  <div class="c2h4-div__course__before">
    <h4 class="c2h4-h4__title">一、检测前准备</h4>
    <ul class="c2h4-ul__before__group">
      <li>1. 擦干净镜头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
      <li>2. 摘眼镜、撩刘海</li>
      <li>3. 不要逆光&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
    </ul>
  </div>
  <div class="c2h4-div__course__then">
    <h4 class="c2h4-h4__title">二、点击“开始拍照”按钮，选择相机拍照</h4>
    <div class="c2h4-div__then__item" v-for="(item, index) in thenable" :key="index" :style="index===0 ? 'margin-top: 13.333333vw' : ''">
      <img :src="item.thumb" :alt="item.descrip" class="c2h4-img__thumb" />
      <p class="c2h4-p__then__descrip">{{item.descrip}}</p>
    </div>
  </div>
  <div class="c2h4-div__user__agreement">
    <div class="c2h4-div__user__check" @click="handleAgreement">
      <img :src="!!agreementState.check ? agreementState.agreeIcon : agreementState.unagreeIcon" alt="用户协议" />
      <a class="c2h4-a__user__agreement" href="https://api.c2h4.org/agreement/">同意:《你今天真好看用户服务协议》</a>
    </div>
  </div>
  <input type="file" id="getPhoto" accept="image/*" capture="camera" style="display: none;" @change="handleFile"/>
  <button class="c2h4-button__begin" id="photoTrigger" :style="'background-color:' + (!!agreementState.check ? '#64c8c8' : '#d8d8d8')+';'" @click="handleBegin">开始「肤质检测」</button>
  <common-footer class="footer"></common-footer>
</div>
</template>

<script>
import step1 from './img/img-steps-1@2x.png'
import step2 from './img/img-steps-2@2x.png'
import step3 from './img/img-steps-3@2x.png'
import agreeIcon from './img/agreement.png'
import unagreeIcon from './img/unagreement.png'
import commonFooter from '../common/footer/index.vue'

export default {
  methods: {
    handleAgreement () {
      this.agreementState.check = !this.agreementState.check
    },
    handleBegin () {
      this.clickCount++
      const input = document.getElementById('getPhoto')
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
      })
      window.BD_MMS_SKILL.sendLog()
      if (this.agreementState.check) {
        let triggerEvent = input.dispatchEvent(event)
        if (!triggerEvent) {
          alert('请更换浏览器重试')
        }
      }
    },
    handleFile (e) {
      if (e.target.files[0]) {
        this.$store.dispatch({
          type: 'storePhoto',
          photo: e.target.files[0]
        })
        this.$router.push('/upload')
      }
    },
    subPhoto () {
      this.$router.push('/loading')
    }
  },
  data () {
    return {
      clickCount: 0,
      thenable: [
        {
          thumb: step1,
          descrip: '1.进入拍照页后，请打开闪光灯，并使用后置摄像头拍摄'
        },
        {
          thumb: step2,
          descrip: '2.平视镜头，调整至合适距离'
        },
        {
          thumb: step3,
          descrip: '3.按手机的音量减键拍照'
        }
      ],
      agreementState: {
        check: true,
        agreeIcon: agreeIcon,
        unagreeIcon: unagreeIcon
      }
    }
  },
  components: {
    'common-footer': commonFooter
  }
}
</script>

<style scoped>
.c2h4-div__course{
  width: 100%;
}
.c2h4-div__course >img {
  width: 100px;
  height: 50px;
}
.c2h4-h4__course__title{
  margin: 0;
  text-align: center;
  color: #64c8c8;
  font-size: 5.33333333vw;
  padding: 10.6666667vw 0 9.3333333vw 0;
}
.c2h4-h4__title{
  box-sizing:border-box;
  padding: 4vw;
  font-size: 4.8vw;
  color: #323232;
  margin:0;
}
.c2h4-ul__before__group{
  margin:0;
  padding:0;
  list-style: none;
}
.c2h4-ul__before__group li{
  width: 100%;
  text-align: center;
  padding: 4vw 0;
}
.c2h4-div__then__item{
  margin-bottom: 23.733333333vw;
}
.c2h4-p__then__descrip{
  font-size: 4vw;
  color: #646464;
  padding: 0 14.133333333vw;
  text-align: center;
}
.c2h4-img__thumb{
  width: 100%;
  margin-bottom: 10.133333333vw;
}
.c2h4-div__user__agreement{
  text-align: center;
}
.c2h4-div__user__check{
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c2h4-div__user__check img{
  display: inline-block;
  width:3.73333333vw;
  height: 3.733333333vw;
  vertical-align: top;
  padding-right: 2vw;
}
.c2h4-div__user__check a {
  display: inline-block;
  font-size: 3.2vw;
}
.c2h4-a__user__agreement{
  text-decoration: none;
  color: #646464;
}
.c2h4-button__begin{
  width: 53.6vw;
  height: 12.2666666667vw;
  outline: none;
  border-radius: 26.66666667vw;
  background-color: #64c8c8;
  border: none;
  display: block;
  margin-right: auto;
  margin-left: auto;
  font-size: 4vw;
  color: #fff;
  margin-top: 6.4vw;
   -webkit-tap-highlight-color: rgba(0,0,0,0);
}
</style>



// WEBPACK FOOTER //
// src/components/Course/index.vue